var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { colorTransition: _vm.formSubmitted } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.formSubmitted
          ? _c("p", { staticClass: "newsletter-form-success" }, [
              _vm._v(_vm._s(_vm.copyConfirm))
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }